import 'lazysizes';
import React from 'react';
import { imgixSource, imgixSrcSet } from './imgix';

export interface Props {
    src: string;
    alt?: string;
    width?: number;
    height?: number;
    style?: object;
    className?: string;
    lazyload?: boolean;
}

export default function Image({
    src,
    lazyload = true,
    width,
    height,
    style,
    className,
    ...rest
}: Props) {
    let source = src;
    let sourceSet;

    if (src && src.match(/imgix\.net/)) {
        source = imgixSource(src, { width, height });
        sourceSet = imgixSrcSet(source);
    }

    if (lazyload) {
        const classNameWithLazyload = `lazyload ${className ? className : ''}`.trim();

        return (
            <img
                src={'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='}
                data-src={source}
                data-srcset={sourceSet}
                className={classNameWithLazyload}
                style={style}
                width={width}
                height={height}
                {...rest}
            />
        );
    }

    return <img src={source} srcSet={sourceSet} className={className} {...rest} />;
}

interface FigureProps extends Props {
    caption?: React.ReactNode;
    className?: string | undefined;
}

export function Figure({ caption, className, ...imageProps }: FigureProps) {
    return (
        <figure className={className}>
            <Image {...imageProps} />
            {caption && <figcaption>{caption}</figcaption>}
        </figure>
    );
}
